import { useNode } from "@craftjs/core";
import { FormControl, FormLabel, Stack, RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material";
import React from "react";

interface CFormProps {
  children?: React.ReactNode;
  action?: any;
  method?: any;
  paddingV?: any;
  paddingH?: any;
  [key: string]: any;
}

export const CForm = ({ 
  children,
  action, 
  paddingV, 
  paddingH, 
  ...props 
}: CFormProps) => {
  const {
    connectors: { connect, drag },
    selected,
  } = useNode((node) => ({
    selected: node.events.selected,
  }));

  const pmstr = (value: any) => {
    return (!isNaN(value) && !isNaN(parseFloat(value))) ? `${value}px` : value;
  }

  return (
    <form
      {...props}
      className="craft-form"
      ref={(val: any) => connect(drag(val))}
      action={action}
      style={{ 
        padding: `${pmstr(paddingV)} ${pmstr(paddingH)} ${pmstr(paddingV)} ${pmstr(paddingH)}`, 
        borderColor: selected ? '#008522' : '#F0F0F0',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {children}
    </form>
  );
};

export const CFormSettings = () => {
  const {
    action,
    method,
    paddingH,
    paddingV,
    actions: { setProp }
  } = useNode((node) => ({
    action: node.data.props.action,
    method: node.data.props.method,
    paddingH: node.data.props.paddingH,
    paddingV: node.data.props.paddingV,
  }));

  return (
    <Stack spacing={2} paddingBottom={4}>
      <FormControl size="small" component="fieldset">
        <FormLabel component="legend">Method</FormLabel>
        <RadioGroup
          defaultValue={method}
          onChange={(e) =>
            setProp((props: any) => (props.method = e.target.value))
          }
          style={{ flexDirection: 'row', gap: '30px' }}
        >
          <FormControlLabel
            label="GET"
            value="get"
            control={<Radio size="small" color="primary" />}
          />
          <FormControlLabel
            label="POST"
            value="post"
            control={<Radio size="small" color="primary" />}
          />
        </RadioGroup>
      </FormControl>
      <Stack direction='row' spacing={4}>
        <FormControl size="small" fullWidth={true} component="fieldset">
          <FormLabel component="legend">Submit URL</FormLabel>
          <TextField
            value={action}
            onChange={(e) =>
              setProp((props: any) => (props.action = e.target.value))
            }
            variant="outlined"
            size="small"
          />
        </FormControl>
      </Stack>
      <Stack direction='row' spacing={2}>
        <FormControl fullWidth={true} margin="normal" component="fieldset">
          <FormLabel component="legend">Padding Vertical</FormLabel>
          <TextField
            value={paddingV}
            onChange={(e) =>
              setProp((props: any) => (props.paddingV = e.target.value))
            }
            variant="outlined"
            size="small"
          />
        </FormControl>
        <FormControl fullWidth={true} margin="normal" component="fieldset">
          <FormLabel component="legend">Padding Horizontal</FormLabel>
          <TextField
            value={paddingH}
            onChange={(e) =>
              setProp((props: any) => (props.paddingH = e.target.value))
            }
            variant="outlined"
            size="small"
          />
        </FormControl>
      </Stack>
    </Stack>
  );
};

export const CFormDefaultProps: CFormProps = {
  method: "get",
  action: "#",
  paddingH: '20px',
  paddingV: '20px',
};

CForm.craft = {
  displayName: "Form",
  props: CFormDefaultProps,
  related: {
    settings: CFormSettings
  }
};
